const APPWRITE_FILE_ID_MAX_LENGTH = 36;
const CAD_GLTF_FILE_ID_PREFIX = 'gltf_';
const APPWRITE_FILE_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;

/**
 * Returns the stable Appwrite file ID used for the GLB preview derived from a
 * metals-project CAD file. Stable IDs make retries idempotent and let the
 * client recover a completed conversion after a refresh.
 */
export function cadFileIdToGltfFileId(cadFileId: string): string {
    if (!APPWRITE_FILE_ID_PATTERN.test(cadFileId)) {
        throw new Error('CAD file ID is not a valid Appwrite file ID.');
    }

    const gltfFileId = `${CAD_GLTF_FILE_ID_PREFIX}${cadFileId}`;
    if (gltfFileId.length > APPWRITE_FILE_ID_MAX_LENGTH) {
        throw new Error('CAD file ID is too long to derive a GLTF file ID.');
    }

    return gltfFileId;
}

export function cadFileNameToGltfFileName(cadFileName: string): string {
    const convertedName = cadFileName.replace(/\.(igs|iges|step|stp)$/i, '.gltf');
    return convertedName === cadFileName ? `${cadFileName}.gltf` : convertedName;
}
